module.exports = __webpack_public_path__ + "img/resource-tech-image-52.66ddb81b.jpg";